import { FC } from 'react'
import gql from 'graphql-tag'
import {
  RecruitListItem_CurrentUserFragment,
  RecruitListItem_ActivityFragment,
} from 'generated/graphql'
import { LinkProps } from 'components/Link'
import ActivityListItem from './ActivityListItem.mobile'

gql`
  fragment RecruitListItem_currentUser on User {
    id
    ...ActivityTableRow_currentUser
    ...ActivityListItem_currentUser
  }
  fragment RecruitListItem_activity on Activity {
    id
    ...ActivityTableRow_activity
    ...ActivityListItem_activity
  }
`

interface RecruitListItemMobileProps {
  isLoading?: boolean
  activity?: RecruitListItem_ActivityFragment
  currentUser?: RecruitListItem_CurrentUserFragment | null
  isRecommend?: boolean
  linkProps?: Partial<LinkProps>
}

const RecruitListItemMobile: FC<RecruitListItemMobileProps> = (props) => {
  const { isLoading, activity, currentUser, isRecommend, linkProps } = props

  return (
    <ActivityListItem
      className="activity-list-item"
      currentUser={currentUser}
      activity={activity}
      isLoading={isLoading}
      isRecommend={isRecommend}
      linkProps={linkProps}
    />
  )
}

export default RecruitListItemMobile
